var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.19 11.66c0-1 .82-1.82 1.82-1.82s1.82.82 1.82 1.82-.82 1.82-1.82 1.82-1.82-.82-1.82-1.82zm1.5 0c0 .18.14.32.32.32s.32-.14.32-.32-.14-.32-.32-.32-.32.14-.32.32z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16.45c-3.6 0-4.75-1.15-4.75-4.75V6C1.25 2.4 2.4 1.25 6 1.25h10c3.6 0 4.75 1.15 4.75 4.75v1.79c0 .21-.09.42-.25.56-.16.14-.37.21-.59.18-.22-.03-.48-.04-.76-.04h-4.28c-1.73 0-2.1.37-2.1 2.1v5.11c0 .41-.34.75-.75.75H6zM2.75 6v5.7c0 2.79.46 3.25 3.25 3.25h5.27v-4.36c0-2.56 1.04-3.6 3.6-3.6h4.38V6c0-2.79-.46-3.25-3.25-3.25H6c-2.79 0-3.25.46-3.25 3.25z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20v-4.3c0-.41.34-.75.75-.75s.75.34.75.75V20c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM2 12.65c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95 20.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H12c.41 0 .75.34.75.75s-.34.75-.75.75H5.95z",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.19 11.66c0-1 .82-1.82 1.82-1.82s1.82.82 1.82 1.82-.82 1.82-1.82 1.82-1.82-.82-1.82-1.82zm1.5 0c0 .18.14.32.32.32s.32-.14.32-.32-.14-.32-.32-.32-.32.14-.32.32z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.15 7.74h-4.28c-2.14 0-2.85.71-2.85 2.85v8.56c0 2.14.71 2.85 2.85 2.85h4.28c2.14 0 2.85-.71 2.85-2.85v-8.56c0-1.83-.52-2.61-2-2.8-.25-.03-.54-.05-.85-.05zm-1.07 3.92a1.071 1.071 0 0 1-2.14 0 1.071 1.071 0 0 1 2.14 0zm-3.21 5.35a2.142 2.142 0 0 1 3.54-1.62c.45.4.74.98.74 1.62 0 1.18-.96 2.14-2.14 2.14-1.18 0-2.14-.96-2.14-2.14z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.12 17.01c0-.64.22-1.27.61-1.77a2.88 2.88 0 0 1 2.28-1.12c.69 0 1.37.25 1.89.7.64.57 1 1.36 1 2.19 0 1.59-1.3 2.89-2.89 2.89s-2.89-1.3-2.89-2.89zm1.79-.85c-.19.24-.29.54-.29.85 0 .77.62 1.39 1.39 1.39.77 0 1.39-.62 1.39-1.39 0-.4-.18-.78-.49-1.06-.24-.21-.57-.33-.9-.33-.43 0-.83.2-1.1.54zM15.19 11.66c0-1 .82-1.82 1.82-1.82s1.82.82 1.82 1.82-.82 1.82-1.82 1.82-1.82-.82-1.82-1.82zm1.5 0c0 .18.14.32.32.32s.32-.14.32-.32-.14-.32-.32-.32-.32.14-.32.32z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDevices);
export default __webpack_public_path__ + "static/media/vuesax-outline-devices.be12f8b24a57421903bbe3e45a60b1c8.svg";
export { ForwardRef as ReactComponent };